import { SettingsSystemCustomFieldsContainer } from 'modules/settings/pods/settings-system/settings-system-custom-fields/settings-system-custom-fields.container';

export const SettingsCustomFieldsScene = () => <SettingsSystemCustomFieldsContainer />;

export default SettingsCustomFieldsScene;
